import { BoundNumberField, BoundNumberFieldProps, useComputed } from "@homebound/beam";
import { ObjectState } from "src/utils/formState";
import { AiFieldSources, AiProposalValue, pendingSources } from "./AiProposalValue";
import { AiFieldProposalFormValue } from "./utils/aiFieldProposalForm";
import { parseAiNumber, pendingProposedValue, resolveAiProposalStatus } from "./utils/bindAiProposal";

// Derive proposedValue from aiProposal so callers cannot supply a conflicting value.
export type BoundAiNumberFieldProps = Omit<BoundNumberFieldProps, "proposedValue"> & {
  aiProposal?: ObjectState<AiFieldProposalFormValue>;
  /** For a field in table cells where we expect a row action instead. */
  hideAiSources?: boolean;
};

export function BoundAiNumberField(props: BoundAiNumberFieldProps) {
  const { field, aiProposal, helperText, hideAiSources, onChange, ...others } = props;
  // Track proposal status and fieldValue so the pending proposal stays in sync.
  const proposedValue = useComputed(() => pendingProposedValue(aiProposal, parseAiNumber), [aiProposal]);
  const originalValue = useComputed(() => field.originalValue, [field]);
  const sources = useComputed(
    () => pendingSources(hideAiSources ? undefined : aiProposal),
    [aiProposal, hideAiSources],
  );
  return (
    <AiProposalValue aiProposal={aiProposal} originalValue={originalValue}>
      <BoundNumberField
        helperText={sources ? <AiFieldSources {...sources} /> : helperText}
        field={field}
        proposedValue={proposedValue}
        onChange={(value) => {
          field.set(value);
          resolveAiProposalStatus(aiProposal, parseAiNumber, value);
          onChange?.(value);
        }}
        {...others}
      />
    </AiProposalValue>
  );
}
